import React from 'react';
import { Box, HStack, Text } from '@chakra-ui/react';

import { ScannerMode } from '../../../../../../RelevoAssignment/model/enums/scanner-mode.enum';
import { useDepositSuccessResult } from '../../../../hooks/use-deposit-success-result.hook';

export const DepositAmountInfo = () => {
  const { mode, isAnyItemExpired, translations, deposit } = useDepositSuccessResult();

  if (mode === ScannerMode.DEPOSIT_RETURN && isAnyItemExpired) {
    return null;
  }

  return (
    <HStack w="100%" spacing="auto" pt={2}>
      <Box w="50%">{translations('deposit_amount')}</Box>
      <Box w="50%">
        <Text>{deposit?.amount.format(deposit.currency)}</Text>
      </Box>
    </HStack>
  );
};
